package br.com.vvrefeicoes.portal.core.util.image

data class PickedImage(
    val bytes: ByteArray,
    val contentType: String,
)

/** `true` quando a plataforma implementa upload de imagem (hoje só no Web). */
expect fun isImageUploadSupported(): Boolean

/** Abre o seletor de imagem da plataforma. Retorna `null` se cancelar ou não suportar. */
expect suspend fun pickImageFile(): PickedImage?
